<template>
  <div class="e_wallet_pos" :class="{ fullscreen: fullscreen }">
    <section v-if="wallet_balance && checkCustomerAdded">
      <div class="row">
        <div class="col-8">
          <h6 class="mb-3">
            {{ $t("name") }} : {{ customer_details.cust_name || "-" }}
          </h6>
          <h6 class="mb-3">
            {{ $t("mobileno") }} : {{ customer_details.cust_mobile || "-" }}
          </h6>
          <h6 class="mb-3">
            {{ $t("emailaddress") }} : {{ customer_details.cust_email || "-" }}
          </h6>
        </div>
        <div class="col-4">
          <div class="d-flex justify-content-center align-items-center">
            <div class="icon-e-wallet"></div>
            <div class="e-wallet-balance">
              {{ parseFloat(wallet_balance).toFixed(this.MIN_FRACTION_DIGITS) || 0 }} {{ currency_code }}
            </div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="w-50 mx-auto">
            <input
              type="text"
              name="walletDebitAmount"
              id="walletDebitAmount"
              ref="walletDebitAmount"
              v-model="inputValue"
              placeholder="Enter Amount"
              class="mobile-number mb-3 whiteBC"
              v-on:keyup.enter="onPayViaWallet()"
              v-on:keydown="
                (e) => {
                  if (
                    !/[0-9]/.test(e.key) &&
                    e.keyCode !== 8 &&
                    e.keyCode !== 190
                  ) {
                    e.preventDefault();
                  }
                }
              "
            />
            <VkeyboardFloat
                :ID="'walletDebitAmount'"
                :onClickFun="
                  () => {
                    keyboardObj.showVKeyboard = !keyboardObj.showVKeyboard;
                  }
                "
              />
              <Vkeyboard
                :inputName="'walletDebitAmount'"
                :showOrHide="keyboardObj.showVKeyboard"
                :initialValue="inputValue"
                @onChangeEvent="() => {}"
                @onKeyEnter="onPayViaWallet()"
                @changeKeyboardInput="inputValue = $event"
                @onClickClose="
                  () => {
                    keyboardObj.showVKeyboard = false;
                  }
                "
              />
          </div>
          <div class="d-flex justify-content-center">
            <button class="btn btn-primary" @click="onPayViaWallet()">
              Redeem
            </button>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <div class="row d-flex justify-content-center" v-if="checkCustomerAdded">
        <div class="col-6">
          <b-form-input
            v-model="customerPhone"
            placeholder="Mobile Number"
            class="mb-3 whiteBC"
            type="search"
            name="customerPhone"
            id="customerPhone"
            ref="customerPhone"
            focus
            tabindex="0"
          ></b-form-input>
          <VkeyboardFloat
                :ID="'customerPhone'"
                :onClickFun="
                  () => {
                    keyboardObj.showPhnKeyboard = !keyboardObj.showPhnKeyboard;
                  }
                "
              />
              <Vkeyboard
                :inputName="'customerPhone'"
                :showOrHide="keyboardObj.showPhnKeyboard"
                :initialValue="customerPhone"
                @onChangeEvent="() => {}"
                @onKeyEnter="onPayViaWallet()"
                @changeKeyboardInput="customerPhone = $event"
                @onClickClose="
                  () => {
                    keyboardObj.showPhnKeyboard = false;
                  }
                "
              />
          <div class="d-flex justify-content-center">
            <button
              @click="verifyCustomer()"
              class="btn btn-primary ew_60_w_btn"
            >
              Send OTP
            </button>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center" v-else>
        <div class="col-6 d-flex justify-content-center">
          <button
            @click="$bvModal.show('addcustmodalcashCard')"
            class="btn btn-primary ew_90_w_btn"
          >
            Add Customer
          </button>
        </div>
      </div>
    </section>
    <AddCustomerDetailsPopup modalId="addcustmodalcashCard" />
    <OTPPopup
      refId="OTPmodal"
      :customerPhone="customerPhone"
      @onSubmitOtp="onSubmitOTP"
      @onResendOtp="verifyCustomer"
    />
  </div>
</template>

<script>
import PosKeyPad from "@/components/Partials/PosKeypad.vue";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";
import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import OTPPopup from "@/components/Partials/OtpModal.vue";

export default {
  components: {
    PosKeyPad,
    AddCustomerDetailsPopup,
    Vkeyboard,
    VkeyboardFloat,
    OTPPopup,
  },
  props: {
    SectionType: {
      type: String,
      default: "topUp",
    },
    curr_code: {
      type: String,
      default: "",
    },
    onClickHandler: { type: Function },
    onClickAddMoney: { type: Function },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyboardObj: {
        showVKeyboard: false,
        showPhnKeyboard: false,
      },
      customer_details: {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
      },
      inputValue: 0,
      wallet_balance: null,
      e_wallet_verification_id: null,
      e_wallet_customer_id: null,
      showVKeyboard: false,
      OTP: "",
      userOtp: "",
      currencyData: "",
      customerPhone: "",
    };
  },
  beforeMount() {
    // this.getCashCardList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["getCustomerDetails", "customer_mobile_number"]),
    onPayViaWallet() {
        console.log('COMING HERE onPayViaWallet');
      if (
        +parseFloat(this.inputValue).toFixed(this.MIN_FRACTION_DIGITS) >
        +parseFloat(this.toPay).toFixed(this.MIN_FRACTION_DIGITS)
      ) {
        console.log("this.inputValue", this.inputValue);
        console.log("this.toPay", this.toPay);
        this.$toasted.show("Amount cannot be greater than ticket price!");
      } else if (!this.inputValue) {
        this.$toasted.show("Please Enter Amount");
      } else if (isNaN(this.inputValue)) {
        this.$toasted.show("Please Enter Valid Amount");
      } else {
        let payload = {
          wallet_balance: +parseFloat(
            this.customer_details.wallet_balance || 0
          ).toFixed(4),
          cust_mobile: this.customer_details.cust_mobile,
          cust_name: this.customer_details.cust_name,
          cust_id: this.customer_details.cust_id,
          cust_email: this.customer_details.cust_email,
          redeem_amount: this.inputValue,
        };
        console.log('payload', payload);
        this.$store.dispatch("applyWalletRedeem", payload);
      }
    },
    checkCustomerAdded() {
      let flag = false;
      if (Object.keys(this.getCustomerDetails).length > 0) {
        this.customerPhone =
          this.getCustomerDetails["cust_mobile"] ||
          this.customer_mobile_number ||
          "";
        flag = true;

        setTimeout(() => {
          this.doFocus();
        }, 1000);
      } else {
        flag = false;
      }
      return flag;
    },
    currency_code() {
      return this.curr_code
        ? this.curr_code
        : this.currencyData
        ? this.currencyData.curr_code
        : "";
    },
    sectionType() {
      return this.SectionType;
    },
    toPay() {
      let total =
        parseFloat(this.$store.getters.TOTAL_AMOUNT || 0) +
        parseFloat(this.selectedFnBItemsTotalPrice || 0) +
        parseFloat(this.TotalAdditionalTaxes || 0) -
        parseFloat(this.$store.getters.getOfferPrice || 0) -
        parseFloat(this.$store.getters.getSwapTotalAmount || 0) -
        parseFloat(this.$store.getters.paid_amount || 0) -
        parseFloat(this.$store.getters.getloyaltyAmount || 0) +
        parseFloat(this.$store.getters.selectedAddonsTotalPrice || 0);
      return total;
    },
  },
  methods: {
    ...mapActions(["applyWalletRedeem"]),
    onChangeOtp(event) {
      console.log("onChangeOtp event", event);
      console.log("onChangeOtp OTP", this.OTP);
    },
    setInputAmount(balance) {
        console.log('this.toPay', this.toPay);
      let ticket_price = +parseFloat(this.toPay).toFixed(4);
      let balance_amount = +parseFloat(balance).toFixed(4);
      if (balance_amount >= ticket_price) {
        this.inputValue = ticket_price;
      } else {
        this.inputValue = balance_amount;
      }
    },
    onSubmitOTP(otp) {
      if (!otp) {
        this.$toasted.show("Please Enter OTP.");
      } else {
        let payload = {
          verification_id: this.e_wallet_verification_id,
          otp: otp,
          customer_id: this.e_wallet_customer_id,
        };
        PosService.VerifyEWalletCustomerByOtp(payload).then((response) => {
          const { data } = response;
          if (data.status) {
            this.wallet_balance = data.wallet_balance;
            if (data.hasOwnProperty("customer_details")) {
              Object.keys(this.customer_details).map((key) => {
                this.customer_details[key] = data.customer_details[key];
              });
            }
            this.setInputAmount(data.wallet_balance);
            this.$bvModal.hide("OTPmodal");
          } else {
            this.$toasted.show(data.message || "Something Went Wrong!");
          }
        });
      }
    },
    verifyCustomer() {
      if (!this.customerPhone) {
        return this.$toasted.show("Please Enter Mobile Number.");
      } else {
        let loader = this.$loading.show();

        let payload = {
          customer_mobile: this.customerPhone,
        };

        PosService.ValidateEWalletCustomer(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.e_wallet_verification_id = data.verification_id;
              this.e_wallet_customer_id = data.customer_id;
              this.$bvModal.show("OTPmodal");
            } else {
              this.$toasted.show(
                data.message || "Something Went Wrong! Please Try Again Later."
              );
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong! Please Try Again Later.");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    doFocus() {
      if (this.$refs.customerPhone) {
        this.$refs.customerPhone.focus();
      }
    },
  },
};
</script>

<style>
.e_wallet_pos {
  position: relative;
}

.whiteBC {
  background-color: #fff !important;
  border: 1px solid #80bdff !important;
}

.e_wallet_pos.fullscreen {
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  height: 100%;
  padding: 16px;
  position: fixed;
  background-color: #fff;
  overflow-y: auto;
}

.e_wallet_pos .section-title {
  margin-bottom: 24px;
}

.e_wallet_pos .btn-modal-close {
  position: absolute;
  top: -11px !important;
}

.e_wallet_pos .list-view-table th:first-child,
.e_wallet_pos .list-view-table td:first-child,
.e_wallet_pos .list-view-table th:last-child,
.e_wallet_pos .list-view-table td:last-child,
.e_wallet_pos .list-view-table th,
.e_wallet_pos .list-view-table td {
  padding: 10px;
}

.e_wallet_pos thead {
  background-color: #f5f5f5;
}

.e_wallet_pos .list-view-table th,
.e_wallet_pos .list-view-table td {
  border-right: 1px solid #eaeaed;
}

.e_wallet_pos .list-view-table th:first-child,
.e_wallet_pos .list-view-table td:first-child {
  border-left: 1px solid #eaeaed;
}

.e_wallet_pos .list-view-table th,
.e_wallet_pos .list-view-table td {
  border-bottom: 1px solid #eaeaed;
}

.e_wallet_pos .e_wallet_pos .list-view-table td {
  word-break: break-all;
}

.ew_90_w_btn {
  width: 90%;
  height: 45px;
}
.ew_60_w_btn {
  width: 60%;
  height: 45px;
}

.e-wallet-balance {
  font-size: 21px;
  font-weight: 500;
  line-height: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/EwalletPos.vue